export default "__VITE_ASSET__D4$GNi5X__"